import Icon from '../components/Icon.vue'

Icon.register({
  snowman: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M510.9 152.3c3.2 8.1-0.8 17.2-8.9 20.3l-135.2 55.2c0.4 4.1 1.2 8 1.2 12.2 0 10-1.7 19.5-4.2 28.7 21.1 21.4 36.1 48.8 41.6 79 11.5 63.2-16.4 120.3-62.9 152.6-10.9 7.6-23.9 11.7-37.2 11.7h-99.2c-11 0-22-2.3-31.3-8.2-42.4-26.9-70.8-73.8-70.8-127.8 0-41.8 16.9-79.6 44.3-107.1-2.5-9.3-4.2-18.8-4.2-28.9 0-4.2 0.8-8.2 1.2-12.2l-135.2-55.2c-8.2-3.2-12.2-12.3-8.9-20.3l5.9-14.5c3.3-8 12.6-11.9 20.8-8.7l28.1 11.5v-29c0-8.6 7.2-15.6 16-15.6h16c8.8 0 16 7 15.8 15.6v46.9c0 0.5-0.2 1-0.3 1.5l56.4 23c6-10 13.3-18.9 22-26.6-13.5-16.6-22-37.4-22-60.5 0-53 43-96 96-96s96 43 96 96c0 23.1-8.4 43.9-22 60.5 8.7 7.7 16.1 16.6 22 26.6l56.4-23c0-0.5-0.3-1-0.3-1.5v-46.9c0-8.6 7.2-15.6 16-15.6h16c8.8 0 16 7 16 15.6v29l28.2-11.5c8.2-3.2 17.5 0.7 20.8 8.7zM224 96c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM256 368c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM256 304c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM256 240c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM256 152c0 0 16-23.2 16-32s-7.2-16-16-16-16 7.2-16 16 16 32 16 32zM288 96c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/snowman.js
// module id = 1912
// module chunks = 0